import {useContext} from "react"
import PusherContext from "contexts/pusher/PusherContext"

export default function usePusher() {
  return useContext(PusherContext)
}